/**
 * Constantes de Atividades Esportivas
 * Define o catálogo de atividades esportivas do EducaPaço
 * 
 * NOTA: Este arquivo substitui o antigo modalidades.js
 */

/**
 * Catálogo de atividades esportivas
 */
export const ATIVIDADES_ESPORTIVAS = {
  FUTEBOL: {
    id: "FUTEBOL",
    nome: "Futebol",
    descricao: "Futebol de campo e futsal",
    categoria: "Coletiva",
    requisitos: null,
  },
  VOLEI: {
    id: "VOLEI",
    nome: "Vôlei",
    descricao: "Voleibol",
    categoria: "Coletiva",
    requisitos: null,
  },
  BASQUETE: {
    id: "BASQUETE",
    nome: "Basquete",
    descricao: "Basquetebol",
    categoria: "Coletiva",
    requisitos: null,
  },
  NATACAO: {
    id: "NATACAO",
    nome: "Natação",
    descricao: "Natação e atividades aquáticas",
    categoria: "Individual",
    requisitos: "Necessita piscina",
  },
  XADREZ: {
    id: "XADREZ",
    nome: "Xadrez",
    descricao: "Xadrez e jogos de raciocínio",
    categoria: "Mental",
    requisitos: null,
  },
  CORRIDA: {
    id: "CORRIDA",
    nome: "Corrida",
    descricao: "Corrida e atletismo",
    categoria: "Individual",
    requisitos: null,
  },
  CAPOEIRA: {
    id: "CAPOEIRA",
    nome: "Capoeira",
    descricao: "Capoeira - Arte marcial brasileira",
    categoria: "Cultural",
    requisitos: null,
  },
  DANCA: {
    id: "DANCA",
    nome: "Dança",
    descricao: "Dança e expressão corporal",
    categoria: "Cultural",
    requisitos: null,
  },
  JUDO: {
    id: "JUDO",
    nome: "Judô",
    descricao: "Judô - Arte marcial",
    categoria: "Individual",
    requisitos: "Necessita tatame",
  },
  HANDEBOL: {
    id: "HANDEBOL",
    nome: "Handebol",
    descricao: "Handebol",
    categoria: "Coletiva",
    requisitos: null,
  },
  FUTSAL: {
    id: "FUTSAL",
    nome: "Futsal",
    descricao: "Futebol de salão",
    categoria: "Coletiva",
    requisitos: null,
  },
  GINASTICA: {
    id: "GINASTICA",
    nome: "Ginástica",
    descricao: "Ginástica artística e rítmica",
    categoria: "Individual",
    requisitos: "Necessita equipamentos específicos",
  },
  TENIS: {
    id: "TENIS",
    nome: "Tênis",
    descricao: "Tênis de mesa ou de campo",
    categoria: "Individual",
    requisitos: null,
  },
};

/**
 * Lista de atividades esportivas para uso em selects
 */
export const ATIVIDADES_ESPORTIVAS_LIST = Object.values(ATIVIDADES_ESPORTIVAS).map(atividade => ({
  value: atividade.id,
  label: atividade.nome,
  description: atividade.descricao,
  categoria: atividade.categoria,
  requisitos: atividade.requisitos,
}));

/**
 * Lista de atividades esportivas coletivas
 */
export const ATIVIDADES_ESPORTIVAS_COLETIVAS = ATIVIDADES_ESPORTIVAS_LIST.filter(a => a.categoria === "Coletiva");

/**
 * Lista de atividades esportivas individuais
 */
export const ATIVIDADES_ESPORTIVAS_INDIVIDUAIS = ATIVIDADES_ESPORTIVAS_LIST.filter(a => a.categoria === "Individual");

/**
 * Lista de atividades esportivas por categoria
 */
export const ATIVIDADES_ESPORTIVAS_POR_CATEGORIA = {
  Coletiva: ATIVIDADES_ESPORTIVAS_COLETIVAS,
  Individual: ATIVIDADES_ESPORTIVAS_INDIVIDUAIS,
  Mental: ATIVIDADES_ESPORTIVAS_LIST.filter(a => a.categoria === "Mental"),
  Cultural: ATIVIDADES_ESPORTIVAS_LIST.filter(a => a.categoria === "Cultural"),
};

/**
 * Obtém uma atividade esportiva por ID
 */
export const getAtividadeEsportivaById = id => {
  return ATIVIDADES_ESPORTIVAS[id] || null;
};

/**
 * Número máximo de preferências esportivas que um aluno pode indicar
 */
export const MAX_PREFERENCIAS_ESPORTIVAS = 4;

/**
 * Valida se o número de preferências está dentro do limite
 */
export const validarPreferenciasEsportivas = preferencias => {
  return {
    valido: preferencias.length <= MAX_PREFERENCIAS_ESPORTIVAS,
    quantidade: preferencias.length,
    maximo: MAX_PREFERENCIAS_ESPORTIVAS,
  };
};

// Aliases para compatibilidade com código legado
export const MODALIDADES = ATIVIDADES_ESPORTIVAS;
export const MODALIDADES_LIST = ATIVIDADES_ESPORTIVAS_LIST;
export const MODALIDADES_COLETIVAS = ATIVIDADES_ESPORTIVAS_COLETIVAS;
export const MODALIDADES_INDIVIDUAIS = ATIVIDADES_ESPORTIVAS_INDIVIDUAIS;
export const MODALIDADES_POR_CATEGORIA = ATIVIDADES_ESPORTIVAS_POR_CATEGORIA;
export const getModalidadeById = getAtividadeEsportivaById;


















